import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type GhostPostArticleModel } from '../models/GhostPostArticleModel';
import { type GhostTagModel } from '../models/GhostPostModel';
import CoreJsonAPIService from './CoreJsonAPIService';
import {type  GhostPostSummaryList } from '../models/GhostPostSummaryListModel';

export class SvNewsService extends CoreJsonAPIService {
  static async getPublicTags() {
    return await super.get<GhostTagModel[]>(EDjangoAppsEndpoints.news, 'tags');
  }

  static async getPost(params: { slug: string }) {
    return await super.get<GhostPostArticleModel>(EDjangoAppsEndpoints.news, `posts/${params.slug}`);
  }

  static async getAllPosts(page: string, tag?: string, order?: string) {
    const params: { page: string; tag?: string; order?: string } = { page };

    if (tag) {
      params.tag = tag;
    }

    if (order) {
      params.order = order;
    }

    return await super.get<GhostPostSummaryList>(EDjangoAppsEndpoints.news, 'posts', params);
  }
}
